import {
  isTypesenseSearchProvider,
  resolveSearchProvider,
  type ResolveSearchProviderOptions,
} from './search-provider-preference';

/** Returns true when the effective search provider is Typesense. */
export function isTypesenseSearchEnabled(options?: ResolveSearchProviderOptions): boolean {
  return isTypesenseSearchProvider(resolveSearchProvider(options));
}
